<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2023-01-11 11:42:17
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2023-01-11 17:22:47
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\pushManagement\dialogComponent\education.vue
 * @tips: 宣传患教弹窗组件
-->
<template>
    <div class=''>
        <el-dialog title="健康宣教" :visible.sync="promoting" width="1200px" v-if="promoting" custom-class="set-health-article" center
            @close="currentId = 0">
            <div style="display:flex">
                <div class="content" style="padding:20px;width:700px;">
                    <el-row type="flex" justify="end">
                        <el-col :span="18">
                            <el-input style="margin-bottom:20px;margin-right:20px" placeholder="请输入宣教标题/主适配病种"
                                v-model="contentSearch" clearable size="small"></el-input>
                        </el-col>
                        <el-col :span="6" style="text-align: right">
                            <el-button size="small" style="margin-right:20px" @click="restMission">重置</el-button>
                            <el-button type="primary" size="small" @click.stop="getMission()"
                                style="margin-left: 0px">搜索
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-table :header-cell-style="{
    textAlign: 'center',
    color: '#333333',
    fontSize: '14px',
    fontWeight: 'bold',
    backgroundColor: '#FAFAFA',
}" :data="promotingTable" style="width: 100%">
                        <el-table-column prop="title" label="宣教标题" align="center"> </el-table-column>
                        <el-table-column label="类型" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.missionType == 1 ? '推荐' : scope.row.missionType ==
        2 ? '提醒' : scope.row.missionType == 3 ? '辅导' : ''
}}</template>
                        </el-table-column>
                        <el-table-column prop="diseaseTypeName" label="主适配病种" align="center"></el-table-column>
                        <el-table-column fixed="right" label="操作" align="center">
                            <template slot-scope="scope">

                                <el-button type="text" @click="handleLookArticle(scope.row)" size="small">预览</el-button>
                                <el-button @click.native.prevent="promotingSend(scope.$index, scope.row)" type="text"
                                    size="small">
                                    选用
                                </el-button>

                            </template>
                        </el-table-column>
                        <template slot="empty"
                            v-if="$store.state.userPlatForm === 'platForm' && defaultIdType === 'hospitalId'">
                            <!-- 仅平台有 -->
                            <div>
                                <div>对应机构暂无数据，是否去平台查找</div>
                                <el-button type="primary" @click="companySearch">搜平台</el-button>
                            </div>
                        </template>
                        <template slot="empty" v-if="defaultIdType === 'companyId' && !promotingTable.length">
                            <!-- 平台搜索过后也无数据的情况下展示 -->
                            <div>
                                <div>暂无数据</div>
                            </div>
                        </template>
                    </el-table>
                    <!-- 分页 -->
                    <div class="cardpage" style="text-align:right;margin-top:20px;margin-right:30px">
                        <el-pagination @size-change="promotingPageSize" @current-change="promotingCurrentChange"
                            :current-page="promotingCurrent" :page-size="promotingPage"
                            layout="total,  prev, pager, next, jumper" :total="promotingTotal">
                        </el-pagination>
                    </div>
                    <!-- </el-scrollbar> -->
                </div>
                <div v-if="currentId" class="phone-container" style="width:500px !important;">
                    <iframe :src="'/phone.html?id=' + currentId" width="100%" height="100%" frameborder="0"></iframe>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { apiGetMission } from '../api/index'
export default {
    data() {
        //这⾥存放数据
        return {
            promoting: false,
            currentId: 0,
            contentSearch: "",
            promotingTable: [],
            defaultIdType: "hospitalId",
            promotingTotal: 0,
            drawer: false,
            promotingPage: 10, 
            promotingCurrent: 1, 
        };
    },
    //监听属性类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //⽅法集合
    methods: {
        //重置
        restMission() {
            this.contentSearch = ''
            this.defaultIdType = "hospitalId"
        },
        //获取数据
        getMission() {
            this.promoting = true;
            apiGetMission({
                current: this.promotingCurrent,
                available: 1,
                title: this.contentSearch,
                deleted: 0,
                promotingCurrent: 1,
            }).then(res => {
                this.promotingTable = res.data.records;
                this.promotingTotal = res.data.total;
            })
        },
        //搜平台
        companySearch() {
            this.defaultIdType = "companyId";
            this.getMission();
        },
        //预览
        handleLookArticle(row) {
            this.drawer = true;
            this.currentId = row.id;
        },
        //分页
        promotingPageSize(val) {
            this.promotingCurrent = val;
            this.getMission();
        },
        promotingCurrentChange(val) {
            this.promotingCurrent = val;
            this.getMission();
        },
        //选择
        promotingSend(index, row) {
            row.emitType = '宣传患教';
            this.$emit('receiveParams',row);
            this.promoting = false;
        },
    },
    //⽣命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //⽣命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.$on('openDialog', () => {
                this.getMission()
            });
        });
    },
    //beforeCreate() {}, //⽣命周期 - 创建之前
    //beforeMount() {}, //⽣命周期 - 挂载之前
    //beforeUpdate() {}, //⽣命周期 - 更新之前
    //updated() {}, //⽣命周期 - 更新之后
    //beforeDestroy() {}, //⽣命周期 - 销毁之前
    //destroyed() {}, //⽣命周期 - 销毁完成
    //activated() {}, //如果页⾯有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
/* @import url(); 引⼊公共css类 */
</style>